import { query } from "kitsu-core"

import isEmptyObject from "~/helpers/is-empty-object"
import { RequestParameters } from "../SohoApi/SohoApi"

export const DEFAULT_FILTER_KEY = 'ALL'

/**
 * Extend the kitsu query formatter and use it as the request id
 *
 * @param {ResourceFilter} filters
 * @returns {string}
 */
export function filterId(filter?: RequestParameters): string {
  if (!filter || isEmptyObject(filter)) {
    return DEFAULT_FILTER_KEY
  }

  return query(filter)
}
